import { type CheckboxProps, Checkbox as MuiCheckbox, Stack, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';

type Props = {
  label?: string | ReactNode;
} & CheckboxProps;

export const Checkbox: FC<Props> = ({ label, ...other }) => (
  <Stack display="flex" direction="row" alignItems="center" gap={1}>
    <MuiCheckbox {...other} sx={{ height: 'fit-content', ...other.sx }} />
    {typeof label === 'string' ? (
      <Typography display="inline-block" sx={{ cursor: 'pointer' }}>
        {label}
      </Typography>
    ) : (
      label
    )}
  </Stack>
);
